<form [formGroup]="form">
  <div fxLayout="row">
    <div fxFlex="25">

      <!-- Ratio -->
      <mat-label>{{ 'ratio' | translate }} {{ 'bvo' | translate: 'upperCase' }} / {{ 'fno' | translate: 'upperCase' }}</mat-label>
      <mat-form-field>
        <input matInput 
          type="number" 
          placeholder="{{ 'ratio' | translate }}" 
          formControlName="ratio"
          (keydown.enter)="$event.target.blur()">
        <span matSuffix>/ 1</span>
      </mat-form-field>

    </div>
    <div fxFlex="25">

      <!-- FNO -->
      <mat-label>{{ 'cluster' | translate }} {{ 'fno' | translate: 'upperCase' }}</mat-label>
      <mat-form-field>
        <input matInput type="number" placeholder="{{ 'fno' | translate: 'upperCase' }}" formControlName="fno">
        <span matSuffix>m<sup>2</sup></span>
      </mat-form-field>

    </div>
    <div fxFlex="25">

      <!-- BVO -->
      <mat-label>{{ 'cluster' | translate }} {{ 'bvo' | translate: 'upperCase' }}</mat-label>
      <mat-form-field>
        <input matInput 
          type="number"
          placeholder="{{ 'bvo' | translate: 'upperCase' }}"
          formControlName="bvo"
          (keydown.enter)="$event.target.blur()">
        <span matSuffix>m<sup>2</sup></span>
      </mat-form-field>

    </div>
    <div fxFlex="25">

      <!-- BUI -->
      <mat-label>{{ 'cluster' | translate }} {{ 'bui' | translate: 'upperCase' }}</mat-label>
      <mat-form-field>
        <input matInput type="number" placeholder="{{ 'bui' | translate: 'upperCase' }}" formControlName="bui">
        <span matSuffix>m<sup>2</sup></span>
      </mat-form-field>

    </div>
  </div>
</form>
